import { render, staticRenderFns } from "./PainelClassTurma.vue?vue&type=template&id=a3774d00&"
import script from "./PainelClassTurma.vue?vue&type=script&lang=js&"
export * from "./PainelClassTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports